import {
  BabyPeekMobleTraitsMenuContainer,
  BabyPeekMobleTraitsMenuItem,
} from "../../BabyPeekViewResults.styles";
import { Trait } from "../../Services/BabyPeekService";
import { getBabyPeekTraitLabel } from "../../BabyPeekI18n";

const traitArray = [
  "Asparagus",
  "Bitter",
  "Cilantro",
  "EyeColor",
  "Freckle",
  "CurlyHair",
  "HairThickness",
  "LightOrDarkHair",
  "RedHair",
  "Sweet",
  "SweetSalty",
  "BabyTeeth",
] as Trait[];

export const TraitMenu = (
  setCurrentTrait: (trait: Trait) => void,
  currentTrait: Trait,
): React.ReactElement => (
  <BabyPeekMobleTraitsMenuContainer>
    {traitArray.map((trait) => (
      <BabyPeekMobleTraitsMenuItem
        onClick={() => setCurrentTrait(trait)}
        selected={currentTrait === trait}
      >
        {getBabyPeekTraitLabel(trait)}
      </BabyPeekMobleTraitsMenuItem>
    ))}
  </BabyPeekMobleTraitsMenuContainer>
);
